// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { Models } from '@rematch/core'
import { auth } from './auth'
import { cameras } from './carmeras'
import { download } from './download'
import { jobList } from './jobList'
import { city } from './city'
import { map } from './map'
import { road } from './road'
import { admin } from './admin'
import { rbacCurrent } from './rbacCurrent'
import { geofence } from './geofence'
import { app } from './app'
import { cameraFinder } from './camera-finder'
import { firmware } from './firmware'
import { directory } from './directory'
import { gpsTrace } from './gps-trace'
import { statusTrace } from './status-trace'
import { dongleDevices } from './dongle-devices'
import {imageUploadType} from './imageUploadType'

export interface RootModel extends Models {
  cameras: typeof cameras
  download: typeof download
  map: typeof map
  auth: typeof auth
  jobList: typeof jobList
  city: typeof city
  road: typeof road
  admin: typeof admin
  rbacCurrent: typeof rbacCurrent
  geofence: typeof geofence
  app: typeof app
  cameraFinder: typeof cameraFinder
  firmware: typeof firmware
  directory: typeof directory
  gpsTrace: typeof gpsTrace
  statusTrace: typeof statusTrace
  dongleDevices: typeof dongleDevices
  imageUploadType: typeof imageUploadType
}

export const models: RootModel = {
  cameras,
  download,
  map,
  auth,
  jobList,
  city,
  road,
  admin,
  rbacCurrent,
  geofence,
  app,
  cameraFinder,
  firmware,
  directory,
  gpsTrace,
  statusTrace,
  dongleDevices,
  imageUploadType
}
